module.exports = __webpack_public_path__ + "img/guaranteed-safe-checkout-02.75224e4b.png";